export default {
  de: {
    name: 'Service',
    host: 'Host',
    protocol: 'Protokoll',
    port: 'Port',
    online: 'Online',
    plural: 'Services'
  }
}
